import axios from "axios";
import i18n from "../i18n";
import { axiosInstance } from "../App";
  export async function getUser():Promise<any> {
    
    return axiosInstance
      .get(process.env.REACT_APP_API_HOST_TEST + "db/testConnection", {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language, // Add current language
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  }
  export async function getToken(payload: any):Promise<any> {
    const body = {
      username: payload.email,
      password: payload.password,
      grant_type: '',
    scope: '',
    client_id: '',
    client_secret: '',
    };
    return axiosInstance
      .post(process.env.REACT_APP_API_HOST_TEST + "token", body, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Accept-Language": i18n.language, // Add current language
        },
      })
      .then((response) => {
        return response;
      });
  }